export default __webpack_public_path__ + "1255bc0445d4127960b860393ba0bbd1.png";